"use strict";

var compareTo = function () {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function (scope, element, attributes, ngModel) {

            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue == scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }
    };
};

var appDirectives = angular.module("app.directives", []);

appDirectives.config(() => {
    var model: string = document.getElementById("model").textContent.trim();
    var dictionary: any = JSON.parse(model);

    for (var key in dictionary) {
        module.constant(key, dictionary[key]);
    }
});

appDirectives.directive("appVersion", function () {
    var model: string = document.getElementById("model").textContent.trim();
    var dictionary: any = JSON.parse(model);
    var version = dictionary['websiteVersionNumber'];
    return {
        template: 'Version: ' + version
    };
});

appDirectives.directive("compareTo", compareTo);

appDirectives.directive('showErrors', function () {
    return {
        restrict: 'A',
        require: '^form',
        link: function (scope, el, attrs, formCtrl) {
            // find the text box element, which has the 'name' attribute
            var inputEl = el[0].querySelector("[name]");
            // convert the native text box element to an angular element
            var inputNgEl = angular.element(inputEl);
            // get the name on the text box so we know the property to check
            // on the form controller
            var inputName = inputNgEl.attr('name');

            // only apply the has-error class after the user leaves the text box
            inputNgEl.bind('blur', function () {
                el.toggleClass('has-error', formCtrl[inputName].$invalid);
            })
        }
    }
});

appDirectives.directive('addressForm', function () {
    return {
        restrict: 'E',
        templateUrl: 'assets/templates/accountDetails/addressForm.html',
        scope: {
            addressTitle: '@',
            address: '=', // allows data to be passed into directive from controller scope
            selectedAccount: '<',
            mailAddressForm: '=',
            isDisabled: '<'
        }
    };
});

// Note: rendered as <market-depth-form></market-depth-form>
appDirectives.directive('marketDepthForm', function () {
    return {
        restrict: 'E',
        templateUrl: 'assets/templates/portfolioSummary/components/marketDepth.component.html'
    };
});

appDirectives.directive('holdingsSummary', function () {
    return {
        restrict: 'E',
        templateUrl: 'assets/templates/portfolioSummary/holdingsSummary.html',
    };
});

appDirectives.directive('marketOrdersSummary', function () {
    return {
       restrict: 'E',
       controller: Patersons.MarketOrdersCtrl,
        templateUrl: 'assets/templates/portfolioSummary/marketOrdersSummary.html'
    };
});

appDirectives.directive('errSrc', function () {
    return {
        link: function (scope, element, attrs:any) {
            element.bind('error', function () {
                if (attrs.src != attrs.errSrc) {
                    attrs.$set('src', attrs.errSrc);
                }
            });

            attrs.$observe('ngSrc', function (value) {
                if (!value && attrs.errSrc) {
                    attrs.$set('src', attrs.errSrc);
                }
            });
        }
    };
});

appDirectives.directive("isNotDuplicate", ["$q", function ($q) {
    return {
        require: "ngModel",
        link: function (scope, elm, attrs, ctrl: any) {
            ctrl.$asyncValidators.isNotDuplicate = function (modelValue: string, viewValue: string) {
                if (ctrl.$isEmpty(viewValue)) {
                    return $q.resolve();
                }

                var existing = attrs.isNotDuplicate.split("|");

                var def = $q.defer();
                if (existing.indexOf(viewValue.toLowerCase()) === -1) {
                    def.resolve();
                } else {
                    def.reject();
                }

                return def.promise;
            };
        }
    };
}]);

appDirectives.directive("dateFormat", ["$q", function ($q) {
    return {
        require: "ngModel",
        link: function (scope, elm, attrs, ctrl: any) {
            ctrl.$asyncValidators.dateFormat = function (modelValue: string, viewValue: string) {
                if (ctrl.$isEmpty(viewValue)) {
                    return $q.resolve();
                }

                // Validate format against dd/dd/dddd
                if (!/^\d\d\/\d\d\/\d\d\d\d$/.test(viewValue)) {
                    return $q.reject();
                }

                if (!moment(viewValue, "DD/MM/YYYY").isValid()) {
                    return $q.reject();
                }

                return $q.resolve();
            }
        }
    };
}]);

appDirectives.directive('passwordMatch', ["$q", function ($q) {
    return {
        restrict: 'A',
        scope:true,
        require: 'ngModel',
        link: function (scope, elem , attrs, control) {
            var checker = function () {
                //get the value of the first password
                var e1 = scope.$eval(attrs.ngModel);
                //get the value of the other password
                var e2 = scope.$eval(attrs.passwordMatch);
                return e1 == e2;
            };
            scope.$watch(checker, function (n) {
                //set the form control to valid if both
                //passwords are the same, else invalid
                control.$setValidity("unique", n);
                //attrs.passwordMatch.$setValidity("pattern", n);
            });
        }
    };
}]);

var defaultTitle = '';
appDirectives.directive('pageTitle', ['$rootScope', '$interpolate', '$state', 'userCompanyService', function ($rootScope, $interpolate, $state, userCompanyService) {


    return {
        restrict: 'A',
        link: function (scope, element) {
            $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                //reset the meta data when a route changes - the document title should be updated by the resolve meta property on each state
                $rootScope.meta = undefined;
            });
            $rootScope.$on('$stateChangeSuccess', function (event, toState) {
                userCompanyService.getUserCompany().then((company) => {
                    defaultTitle = company.companyName;
                    var  separateBy = ' - ';
                    if ($rootScope.meta && $rootScope.meta.title) {
                      var stateTitle = $rootScope.meta.title;
                      element.html(stateTitle + separateBy + defaultTitle);
                      $rootScope.$emit('$titleChangeSuccess', stateTitle + separateBy + defaultTitle);
                    } else {
                      element.html(defaultTitle);
                      $rootScope.$emit('$titleChangeSuccess', defaultTitle);
                    }
                })
              });
        }
    }
}]);